var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apvrule"},[_c('p',{staticClass:"ruleTitle"},[_vm._v("合同审批制度")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.ruleDetail)}})])}
var staticRenderFns = []

export { render, staticRenderFns }